export const CREATE_CAMPAIGN = "/sponsor/create-campaign";
export const DRAFTED_CAMPAIGNS = "/sponsor/drafted-campaigns";
export const ALL_CAMPAIGNS = "/sponsor/campaigns";
export const EDIT_SINGLE_CAMPAIGN = "/sponsor/edit-campaign";
